package com.essntl.core.settings.domain.model.configuration

data class ConfigurationEmailModel(
    val from: String,
    val bcc: String,
    val replyTo: String,
    val waypointSimpleTemplateId: String,
    val waypointMultiTemplateId: String,
)
